/* eslint-disable quotes */
import { escapeHtml } from '../../utils/lodash-replacements';

export default () => {
  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;
  const cart_items = [];

  window.cart.items.forEach((product) => {
    const color_option = product.options_with_values.find((o) => o.name === `Color`);
    const product_color = color_option ? color_option.value : ``;
    const size_option = product.options_with_values.find((o) => o.name === `Size`);
    const product_size = size_option ? size_option.value : ``;

    // Hacky way to find style_number via the image naming convention
    let product_style = '';
    if (product.image.includes(`/`)) {
      let product_image_split = product.image.split(`/`);
      if (product_image_split.length > 1) {
        let product_image_split_last = product_image_split[product_image_split.length - 1];
        if (product_image_split_last.includes(`_`)) {
          let product_image_split_split = product_image_split_last.split(`_`);
          if (product_image_split_split.length > 1) {
            product_style = product_image_split_split[0];
          }
        }
      }
    }
    if (product_style === '') {
      console.warn(`WARNING: Product style is missing for ID: ${product.id}`);
    }
    const admind_product = {
      id: product.product_id,
      variant: product.variant_id,
      style: escapeHtml(product_style || ``),
      // category: ,
      subcategory: escapeHtml(product.product_type),
      name: escapeHtml(product.title),
      price: Number((product.price / 100).toFixed(2)),
      originalPrice: Number((product.original_price / 100).toFixed(2)),
      newArrival: false,
      isMarkedDown: product.price < product.original_price,
      quantity: Math.abs(product.quantity),
      subtotal: Number(((product.price / 100) * Math.abs(product.quantity)).toFixed(2)),
      hasCoupon: product.discounts.length > 0,
      couponDiscountValue: product.total_discount,
      // percentOff: ,
      hasReviews: false,
      reviewCount: 0,
      reviewAverage: 0,
      color: escapeHtml(product_color),
      size: escapeHtml(product_size),
      showsQuadpay: quadpay_country && Number(product.price) > 1900,
      // defaulting as we don't have access to inventories at this point
      almostGone: false,
      coupon: ``,
    };

    cart_items.push(admind_product);
  });

  const shopify_page = window.ShopifyAnalytics.meta.page;
  let shopify_page_type = shopify_page.pageType;
  // Checkout Page Type
  if (!shopify_page_type) {
    if (shopify_page.path && shopify_page.path.indexOf('checkout') > -1) {
      shopify_page_type = `checkout`;
    }
    if (window.location.pathname === `/account`) {
      shopify_page_type = `account`;
    }
    if (window.location.pathname === `/cart`) {
      shopify_page_type = `cart`;
    }
  } else if (shopify_page_type === `page`) {
    if (window.location.pathname === `/pages/search`) {
      shopify_page_type = `search`;
    } else if (window.location.pathname === `/pages/locations`) {
      shopify_page_type = `locator`;
    }
  }
  const admind_page_types = {
    home: `Home`,
    product: `PDP`,
    collection: `Category`,
    page: `Other`,
    checkout: `Checkout`,
    blog: 'Blog',
    search: 'Search',
    locator: 'Locator',
    account: 'Account',
    cart: 'Cart',
  };

  const page_type =
    shopify_page_type && admind_page_types[shopify_page_type] ? admind_page_types[shopify_page_type] : `Other`;

  const admind_info = {
    event: `pageload`,
    user: {
      id: window.theme.customerid || ``,
      loggedIn: Boolean(window.theme.customerid),
      lifetimeValue: window.theme.customer_total_spent || 0,
      existingCustomer: window.theme.customerid ? `Yes` : `No`,
      subscribedToNewsletter: window.theme.accepts_marketing === `true` ? `Yes` : `No`,
      freeShippingThreshold: 0,
      specials: [],
      firstName: escapeHtml(window.theme.customer_first_name) || ``,
      lastName: escapeHtml(window.theme.customer_last_name),
      email: escapeHtml(window.theme.customer_email) || ``,
      email2: ``,
      telephone: escapeHtml(window.theme.customer_phone),
      hashedEmail: window.theme.customer_hashedEmail || ``,
    },
    countryCode: country,
    currency: escapeHtml(window.cart.currency),
    page: {
      path: escapeHtml(window.location.pathname) || ``,
      type: escapeHtml(page_type),
      category: escapeHtml(page_type),
      ecomm_pagetype: escapeHtml(page_type),
    },
    cart: {
      summaryQty: window.cart.item_count,
      value: window.cart.total_price,
      currency: window.cart.currency,
      products: cart_items,
    },
  };

  const dataLayer = window.dataLayer || [];
  dataLayer.push(admind_info);
};
